import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { enableAkitaProdMode, persistState } from '@datorama/akita';
import { environment } from './environments/environment';
import './app/shared/array/array';
import { environmentLoader } from './environments/environment-loader';
import { AppModule } from './app/app.module';

/**
 * Загрузочная заставка из index.html. Она уже на экране к моменту, когда выполняется этот
 * файл, и снимается только отсюда: полоса отмечает пройденные этапы, а не течение времени.
 * Отсутствие объекта — нормальный случай (свой index.html в тестовом стенде), поэтому всё
 * через `?.`.
 */
const boot = (
  window as unknown as {
    raisBoot?: { step(fraction: number, text?: string): void; fail(text?: string): void; done(): void };
  }
).raisBoot;

void environmentLoader
  .then((env) => {
    environment.settings = env.settings;
    boot?.step(0.45);

    if (environment.settings.production) {
      enableProdMode();
      enableAkitaProdMode();
      console.log('Production console logging is disabled');
      console.log('Считаешь, что можешь разобраться и что-то улучшить? Пиши gtihonov@quattrolab.ru ;)');
      window.console.log = () => {};
      window.console.debug = () => {};
    }

    // enableProdMode();
    persistState({
      include: ['user'],
      key: 'user',
    });

    boot?.step(0.72);

    return platformBrowserDynamic().bootstrapModule(AppModule);
  })
  .then(() => boot?.done())
  .catch((err) => {
    console.error(err);
    // Заставка остаётся на экране и называет отказ: в киоске консоли не видно.
    boot?.fail();
  });
